var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.local.isProcessing)?_c('Loader',{attrs:{"cover":""}}):_vm._e(),_c('Filters',{attrs:{"mode":_vm.mode}}),_c('ListTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }